"use client";
import { useState, useEffect } from "react";
import { PDFViewer } from "./../pDFViewer";
import { get_pdf_urls } from './../../../functions';
import type { PdfDocumentData } from './../../../interfaces'

export default function PdfDynamic({ baseId }: { baseId: string }) {
  const [data, setData] = useState<any>(null);
  const { pdfInfoUrl, pdfUrl, pdfSiteUrl } = get_pdf_urls(baseId);

  useEffect(() => {
    fetch(pdfInfoUrl)
      .then((r) => r.json())
      .then((d) => {
        let pdfKeywords = d.combined_keywords || d.keywords_keybert?.map((x: any) => x[0]);
        const pdfKeywordString = (pdfKeywords || []).join(', ')
        const pdfTitle = d.document_title || d.filename || baseId;
        const pdfSummary = d.document_summary || d.summary || "No summary available."
        const pdfAuthor = d.author || "The Daily Dialectics"
        const pdfDescription = d.document_summary || d.summary
        const pdfThumbnailUrl = d.thumbnailUrl || undefined
        const pdfDatePublished = d.date || new Date().toISOString()
        const parsedData: PdfDocumentData = {
          pdfTitle,
          pdfSummary,
          pdfKeywords,
          pdfKeywordString,
          pdfUrl,
          pdfInfoUrl,
          pdfAuthor,
          pdfDescription,
          pdfDatePublished,
          pdfSiteUrl,
          pdfThumbnailUrl,
        };
        setData(parsedData);
      });
  }, [baseId]);

  if (!data) return <p>Loading document…</p>;

  return <PDFViewer baseId={baseId} />;
}
